import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./BasePage.module.css";

import ReactLoading from "react-loading";
import ErrorMessage from "../../components/shared/ErrorMessage";

const apiBaseUrl = process.env.REACT_APP_API_URL;

// tile that shows unit information
function BasePage() {
  const navigate = useNavigate();

  const {
    data: clients,
    error: clientsError,
    isLoading: clientsIsLoading,
  } = useQuery(["clientData"], async () => {
      const { data } = await axios.get(`${apiBaseUrl}/clients/`);
      return data}, {
        staleTime: 1000 * 60 * 30, // optional: cache for 5 minutes{
        refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
        cacheTime: 1000 * 60 * 60,  
    });

  if (clientsIsLoading) {
    return (
      <div className="centering-container">
        <ReactLoading type="spin" color="#000" />
      </div>
    )
  }

  if (clientsError) {
    return <ErrorMessage 
      title="Connection Issue"
      error={"There seems to be an issue. Please try again later."}
    />;
  }

  return (
    <div className={styles.content}>
      {clients.map((client) => (
        <>
          <button className="btn" onClick={() => navigate(`/${client.id}`)}>{client.companyName + " Booking"}</button>
          <button className="btn" onClick={() => navigate(`/${client.id}/admin`)}>{client.companyName + " Admin"}</button>
        </>
      ))}
    </div>
  );
}

export default BasePage;